import { Button } from "@myloc/myloc-gui";
import PropTypes from "prop-types";
import { useCallback, useState } from "react";
import { useTranslate } from "../../../../language/i18n";
import { openOrderPopup } from "../../../../reducers/dialog/dialogAction";

const ProductCatalogueOrderButton = ({ hasOrder, product, onClick, customCssClass, disabled }) => {
  const [isLoading, setIsLoading] = useState(false);
  const translate = useTranslate();

  const onClickButton = useCallback(
    async (productRef, webOrder) => {
      setIsLoading(true);
      try {
        await onClick(productRef, webOrder);
      } finally {
        setIsLoading(false);
      }
    },
    [onClick],
  );

  const openPopupWithoutReferencedOrder = useCallback(() => {
    openOrderPopup({ includeNavigation: false, productRef: product.id, addToCart: onClickButton });
  }, [product.id, onClickButton]);

  // Shown as unavailable while the click is in flight, so a second click is not invited. What actually
  // stops one is the guard in useIdempotentSubmit - button state is decided too late to rely on.
  const isDisabled = disabled || isLoading;

  {
    return (
      <Button
        customCssClass={customCssClass}
        onClick={!hasOrder ? openPopupWithoutReferencedOrder : onClickButton}
        isLoading={isLoading}
        disabled={isDisabled}
      >
        {translate("ADD_TO_CART")}
      </Button>
    );
  }
};

ProductCatalogueOrderButton.propTypes = {
  hasOrder: PropTypes.bool,
  product: PropTypes.shape({ id: PropTypes.string }),
  onClick: PropTypes.func,
  customCssClass: PropTypes.string,
  disabled: PropTypes.bool,
};

export default ProductCatalogueOrderButton;
